import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=10701a85&scoped=true"
import script from "./NoResults.vue?vue&type=script&setup=true&lang=js"
export * from "./NoResults.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=10701a85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10701a85",
  null
  
)

export default component.exports